import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { I18nService } from 'src/app/core/i18n';

@Injectable({
  providedIn: 'root'
})
export class DatepickerLocalFormatterService extends NgbDateParserFormatter {

  constructor(private i18nService: I18nService) {
    super()
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      switch (this.i18nService.language) {
        case 'it':
          return this.italianParse(value);
        case 'en':
          return this.americanParse(value);
        default:
          return this.originalParse(value);
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (date) {
      switch (this.i18nService.language) {
        case 'it':
          return this.italianFormat(date);
        case 'en':
          return this.americanFormat(date);
        default:
          return this.originalFormat(date);
      }
    }
    return '';
  }

  private italianParse(value: string): NgbDateStruct {
    // will parse date in this format: dd-mm-yyyy
    const dateParts = value.trim().split('-');

    let dateObj: NgbDateStruct = {
      day: parseInt(dateParts[0], 10) || null,
      month: parseInt(dateParts[1], 10) || null,
      year: parseInt(dateParts[2], 10) || null
    };
    return dateObj;
  }

  private italianFormat(date: NgbDateStruct): string {
    // will return date in this format: "dd-mm-yyyy"
    return `${date.day.toString().padStart(2, '0')}-${date.month.toString().padStart(2, '0')}-${date.year || ''}`;
  }

  private americanParse(value: string): NgbDateStruct {
    // will parse date in this format: mm-dd-yyyy
    const dateParts = value.trim().split('-');

    let dateObj: NgbDateStruct = {
      day: parseInt(dateParts[1], 10) || null,
      month: parseInt(dateParts[0], 10) || null,
      year: parseInt(dateParts[2], 10) || null
    };
    return dateObj;
  }

  private americanFormat(date: NgbDateStruct): string {
    // will return date in this format: "mm-dd-yyyy"
    return `${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}-${date.year || ''}`;
  }

  private originalParse(value: string): NgbDateStruct {
    const dateParts = value.trim().split('-');

    let dateObj: NgbDateStruct = {
      day: parseInt(dateParts[2], 10) || null,
      month: parseInt(dateParts[1], 10) || null,
      year: parseInt(dateParts[0], 10) || null
    };
    return dateObj;
  }

  private originalFormat(date: NgbDateStruct): string {
    // will return date in this format: "yyyy-mm-dd"
    return `${date.year || ''}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;
  }

}
